import { render, staticRenderFns } from "./ElementVotes.vue?vue&type=template&id=fa71b86c&scoped=true&"
import script from "./ElementVotes.vue?vue&type=script&lang=js&"
export * from "./ElementVotes.vue?vue&type=script&lang=js&"
import style0 from "./ElementVotes.vue?vue&type=style&index=0&id=fa71b86c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa71b86c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
